import { z } from "zod";
import { Id } from "./workspace.entity.ts";

export const RemoveGrantInput = z
	.object({
		orgId: Id,
		targetUid: Id.describe("the member whose grant is being deleted"),
		scope: z.discriminatedUnion("kind", [
			z.object({ kind: z.literal("organization") }).strict(),
			z.object({ kind: z.literal("event"), eventId: Id }).strict(),
		]),
	})
	.strict();
export type RemoveGrantInput = z.infer<typeof RemoveGrantInput>;

export const RemoveGrantOutput = z.object({ ok: z.literal(true) }).strict();
export type RemoveGrantOutput = z.infer<typeof RemoveGrantOutput>;
